import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

// Allow per-page customization for contrast and visibility
const ParticlesBackground = ({
  color = '#ddddddff',
  withLinks = false,
  linkColor = '#e7e7e7ff',
  density = 800,
  opacity = 1,
  sizeMin = 1,
  sizeMax = 1.5,
  speed = 1.1,
  zIndex = 0,
  blendMode = 'normal',
  style: styleProp
}) => {
  const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
      console.log('Particles engine initialized');
    }).then(() => setEngineReady(true));
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log('Particles loaded:', container);
  }, []);

  const particlesOptions = useMemo(() => ({
    background: {
      color: { value: 'transparent' },
    },
    fullScreen: { enable: false },
    fpsLimit: 120,
    interactivity: {
      detectsOn: 'window',
      events: {
        onHover: { enable: true, mode: 'attract' },
        onClick: { enable: false },
        resize: true,
      },
      modes: {
        push: { quantity: 4 },
        repulse: { distance: 200, duration: 0.4 },
        attract: { distance: 100, duration: 0.1, speed: 0.5 },
      },
    },
    particles: {
      color: { value: color },
      links: { color: { value: linkColor }, distance: 100, enable: withLinks, opacity: 0.8, width: 1 },
      move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, random: true, speed: speed, straight: false },
      number: { density: { enable: true, area: 1200 }, value: density },
      opacity: { value: opacity, animation: { enable: true, speed: 1, minimumValue: 0.6, startValue: 'random', sync: false } },
      shape: { type: 'circle' },
      size: { value: { min: sizeMin, max: sizeMax }, animation: { enable: true, speed: 2, minimumValue: sizeMin, sync: false } },
    },
    detectRetina: true,
  }), [color, withLinks, linkColor, density, opacity, sizeMin, sizeMax, speed]);

  if (!engineReady) return null;

  return (
    <div className="pointer-events-none fixed inset-0 w-full h-full" style={{ pointerEvents: 'none', zIndex, mixBlendMode: blendMode, ...(styleProp || {}) }}>
      <Particles 
        id="tsparticles" 
        loaded={particlesLoaded} 
        options={particlesOptions} 
        className="w-full h-full"
        style={{ pointerEvents: 'none' }} 
      />
    </div>
  );
};

export default ParticlesBackground;